import React, { useState, useCallback, useEffect } from 'react'
import Slider from 'react-slick'
import Banner1 from 'custom/assets/dashboard/banner-2.png'
import './adBanner.css'
import DashboardService from '../../services/dashboard.service'
import { useDispatch, useSelector } from 'react-redux'
import { offerListSelector } from '../../store/selectors/app.selector'
import { setOffers } from '../../store/actions/app.actions'

export default function AdBanner() {
  const [offerList, setOfferList] = useState([])
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const offers = useSelector(offerListSelector)

  useEffect(() => {
    fetchOffers()
  }, [])

  const fetchOffers = useCallback(async () => {
    try {
      if (offers.length > 0) {
        setOfferList(offers)
        return
      }
      const response = await DashboardService.getOffers()
      if (response.status === 200) {
        setOfferList(response.data['offers'])
        dispatch(setOffers(response.data['offers']))

        setLoading(false)
      }
    } catch (err) {
      setLoading(false)
    }
  }, [])

  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
  }
  const bannerList = [
    {
      img: Banner1
    }
  ]

  return (
    <>
      {offerList.length == 0 && (
        <Slider {...settings}>
          {bannerList.map((b, i) => (
            <div key={i}>
              <img src={b.img} alt='' height='138' width='100%' />
            </div>
          ))}
        </Slider>
      )}

      {offerList.length > 0 && (
        <Slider {...settings}>
          {offerList.map((item, index) => (
            <div key={index}>
              <img
                src={`data:image/png;base64, ${item.offerImage}`}
                width='100%'
                height='138'
                alt='offers'
              />
            </div>
          ))}
        </Slider>
      )}
    </>
  )
}
